import React from 'react'
import { FileText } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { tiposDocumentoApi } from '../../api/tabelasBasicas'

const TiposDocumentoPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Tipos de Documento"
      breadcrumb="Tabelas › Básicas"
      icon={<FileText size={17} />}
      cdMaxLen={4}
      nmMaxLen={100}
      api={tiposDocumentoApi}
    />
  )
}

export default TiposDocumentoPage
